import "../proceedView/ProceedView.scss";

export default function LinkExpired({ logoChange }) {
   return (
      <div>
         <div className="c2c_poceedView">
            <div className="subContainer">
               <div className="proceedView">
                  <div className="box">
                     <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                        {logoChange ? (
                           <img
                              src={logoChange}
                              className="c2c_logo"
                              style={{ width: "120px",
                        height: "80px",   objectFit: "contain", marginBottom: "20px" }}
                              alt="Logo"
                           />
                        ) : (
                           <img
                              src="https://uat-front.click2check.com/images/logoBeta.png"
                              className="c2c_logo"
                              style={{ width: "120px",
                        height: "80px",   objectFit: "contain",marginBottom: "20px" }}
                              alt="Logo"
                           />
                        )}
                     </div>

                     <div className="heading">
                        <h2 className="title">{'Link Expired'}</h2>
                     </div>
                     <div className="heading">
                        <p className="text">
                           {
                              'Thank you for using the Click2Check service. Unfortunately, the link you are trying to access has expired or is no longer valid.'
                           }
                        </p>
                     </div>

                     <div className="heading">
                        <p className="text">
                           {
                              'To proceed, please contact your advisor, who will be able to provide you with a new link or assist you further.'
                           }
                        </p>
                     </div>
                  </div>
               </div>
            </div>

            <div style={{ position: "fixed", bottom: "-8px", width: "100%" }}>
               <p
                  style={{
                     display: "flex",
                     justifyContent: "center",
                     color: "#7b7b7b",
                     fontSize: "14px",
                     fontFamily: "Arial",
                  }}
               >
                  Powered by Click2Check
               </p>
            </div>
         </div>
      </div>
   );
}
